import { useState } from 'react';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { useConditionFieldSelect } from '../../../hooks/useConditionFieldSelect';
import Breadcrumbs from './general/Breadcrumbs';
import FilterFamilySelectOptions from './FilterFamilySelectOptions';
import Search from './general/Search';
import PropertyTypeFilter from './general/PropertyTypeFilter';
import PropertyTypeFilterPreview from './general/PropertyTypeFilterPreview';
import styled from 'foundations-theming/utils';
import { ObjectTypeIdRegex } from '../../../filterQueryFormat/ObjectTypeId';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SearchGrowContainer = styled.div.withConfig({
  displayName: "FilterFamilySelect__SearchGrowContainer",
  componentId: "m667yb-0"
})(["flex-grow:1;"]);
const FilterFamilySelect = ({
  filterFamily,
  filterFamilyLabel
}) => {
  const {
    isLoadingFields,
    onSearchChange,
    searchString
  } = useConditionFieldSelect(filterFamily);
  const [localSearchString, setLocalSearchString] = useState('');
  const [propertyTypeFilter, setPropertyTypeFilter] = useState([]);
  return /*#__PURE__*/_jsx(ScrollingColumn, {
    headerContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Breadcrumbs, {
        locationLabel: filterFamilyLabel
      }), /*#__PURE__*/_jsxs(Flex, {
        padding: "400",
        gap: "300",
        children: [/*#__PURE__*/_jsx(SearchGrowContainer, {
          children: /*#__PURE__*/_jsx(Search, {
            onSearchChange: evt => {
              setLocalSearchString(evt.target.value);
              onSearchChange(evt);
            },
            searchPlaceholderAssetLabel: filterFamilyLabel,
            value: localSearchString
          })
        }), /*#__PURE__*/_jsx(PropertyTypeFilter, {
          disabled: !ObjectTypeIdRegex.test(filterFamily),
          tooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.dataExplorer.typeFilter.disabledReason",
            options: {
              assetLabel: filterFamilyLabel
            }
          }),
          onChange: setPropertyTypeFilter,
          values: propertyTypeFilter
        })]
      }), /*#__PURE__*/_jsx(PropertyTypeFilterPreview, {
        propertyTypes: propertyTypeFilter,
        onClear: () => setPropertyTypeFilter([])
      })]
    }),
    children: /*#__PURE__*/_jsx(FilterFamilySelectOptions, {
      filterFamily: filterFamily,
      isLoadingFields: isLoadingFields,
      searchString: searchString,
      propertyTypeFilter: propertyTypeFilter
    })
  });
};
export default FilterFamilySelect;